module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('styled-select', {
    ref: "select",
    staticClass: "campaign-select",
    attrs: {
      "value": _vm.value,
      "size": 2,
      "returnValue": "",
      "options": _vm.options,
      "disabled": _vm.disabled,
      "placeholder": "Select Campaign"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7d9800a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/CampaignDDL.vue
// module id = 1986
// module chunks = 0